import React, { useState, useEffect } from 'react'
import { useAvailableSlots } from "../store/stateProvider"
import { style } from './style'
import Drawer from '../../Drawer'
import useBoolean from '../../../hooks/use-boolean'


const filterOptions = {
  'available_capacity_dose1': 'Dose 1',
  'available_capacity_dose2': 'Dose 2',
  'min_age_limit_18': '18 +',
  'min_age_limit_45': '45 +',
  'covishield': 'Covishield',
  'covaxin': 'Covaxin',
  'sputnik': 'Sputnik V',
  'fee_type_free': 'Free',
  'fee_type_paid': 'Paid'
}

const Filter = (props) => {
  const [data, dispatch] = useAvailableSlots()
  const [isOpen, open, close] = useBoolean(false)
  const { initialSlots, identifier } = data
  const [state, setState] = useState({
    available_capacity: true,
    available_capacity_dose1: false,
    available_capacity_dose2: false,
    covaxin: false,
    covishield: false,
    sputnik: false,
    min_age_limit_18: false,
    min_age_limit_45: false,
    fee_type_free: false,
    fee_type_paid: false
  })

  const filter = (keyword = '', value = '') => {
    if (keyword) {
      setState({ ...state, [keyword]: value })
      dispatch({
        type: 'FILTER',
        keywords: { ...state, [keyword]: value },
        initialSlots: initialSlots
      })
    } else {
      const finalState = {
        available_capacity: true,
        available_capacity_dose1: false,
        available_capacity_dose2: false,
        covaxin: false,
        covishield: false,
        sputnik: false,
        min_age_limit_18: false,
        min_age_limit_45: false,
        fee_type_free: false,
        fee_type_paid: false
      }
      setState(finalState)
      dispatch({
        type: 'FILTER',
        keywords: finalState,
        initialSlots: initialSlots
      })
    }
  }

  useEffect(() => {
    dispatch({
      type: 'FILTER',
      keywords: state,
      initialSlots: initialSlots
    })
  }, [initialSlots])

  useEffect(() => {
    filter()
  }, [identifier])

  const isIndividualFilterSelected = (keywords, state) => {
    let isSelected = false
    keywords.forEach(element => {
      isSelected = isSelected || state[element]
    })
    return isSelected
  }

  const isFilterSelected = () => {
    let isSelected = false
    Object.keys(state).forEach(element => {
      if (element !== 'available_capacity') {
        isSelected = isSelected || state[element]
      }
    })
    return isSelected
  }
  const clearAll = () => {
    if (isFilterSelected()) {
      filter()
    }
  }
  const calculateNumberOfFilterSelected = () => {
    let result = 0
    Object.entries(state).forEach(keyword => {
      if (keyword[0] !== 'available_capacity')
        result = keyword[1] ? result + 1 : result
    })
    return result
  }
  return (
    <div style={style.filterContainer}>
      <div style={style.filterTextContainer}>
        <div style={style.filterKeywordsContainer} onClick={() => open()}>
          <div style={{ display: 'flex' }}>
            {calculateNumberOfFilterSelected() ?
              <>
                <div>
                  <img style={{ position: 'absolute', marginTop: '-2px' }} src={`/icons/ic_filter.svg`} />
                  <img style={{ position: 'relative', left: '10px', marginTop: '-10px' }}
                    src={`/icons/ic_filter${calculateNumberOfFilterSelected()}selected.svg`} />
                </div>
                <div style={{ position: 'relative', left: '20px', top: '2.5px' }}>Filters</div>
              </>
              :
              <>
                <div><img style={{ position: 'absolute', marginTop: '-2px' }} src={`/icons/ic_filter.svg`} /></div>
                <div style={{ position: 'relative', left: '36px', top: '2.5px' }}>Filters</div>
              </>}
          </div>
          <img src={'/icons/ic_down_arrow.svg'} style={style.downArrow} />
        </div>
        <Drawer open={isOpen}
          heading={<div style={style.filterDrawerHeader}>
            <div style={{ display: 'flex' }}>
              {calculateNumberOfFilterSelected() ?
                <>
                  <div>
                    <img style={{ position: 'absolute' }} src={`/icons/ic_filter.svg`} />
                    <img style={{ position: 'relative', left: '10px' }} src={`/icons/ic_filter${calculateNumberOfFilterSelected()}selected.svg`} />
                  </div>
                  <div style={{ position: 'relative', left: '20px', top: '5px' }}>Filters</div>
                </>
                :
                <>
                  <div><img style={{ position: 'absolute' }} src={`/icons/ic_filter.svg`} /></div>
                  <div style={{ position: 'relative', left: '36px', top: '5px' }}>Filters</div>
                </>}
            </div>
          </div>}
          BackdropProps={false}
          onClose={close}
          backgroundColor='#ffffff'
          showIcon={<img src={'/icons/ic_filter.svg'} />}
          containerPadding={{ padding: '28px 24px 67px' }}
        >
          <div>
            <><div style={style.keywordsFlexbox}>
              {Object.keys(filterOptions).map((obj, index) => {
                return (
                  <div key={index} style={style.keywordsFlexboxElement(state[obj])} onClick={() => { filter([obj], !state[obj]) }}
                    isSelected={isIndividualFilterSelected([obj], state)}
                  >{filterOptions[obj]}</div>
                )
              })}
            </div>
              <div style={style.clearAllBox(isFilterSelected())} onClick={clearAll}>Clear all</div>
            </>
          </div>
        </Drawer>
      </div >
    </div >
  )
}
export default Filter